import { FIELDS_ERROR_MESSAGE } from "@/admin/hooks/useFacultyAdderReducer";

const checkHighestLowerThanLowestError = (
  lowestGradeError,
  highestGradeError,
  formValues,
) => {
  if (
    !lowestGradeError &&
    !highestGradeError &&
    formValues.lowestGrade.value.key > formValues.highestGrade.value.key
  ) {
    return FIELDS_ERROR_MESSAGE.highestLowerThanLowest;
  }
  return "";
};
/**
 * Given an object representing the form values, it returns an array with the inputs error messages.
 *
 * @example ['Lowest grade error', 'Highest grade error', 'School error', 'Highest lower than lowest error']
 * @param {Object} formValues - An object with the form values.
 * @returns {Array} An array with the inputs error messages with the shape [lowestGradeError, highestGradeError, schoolError, highestLowerThanLowestError].
 */
export const getInputErrorMessages = (formValues) => {
  const lowestGradeError =
    formValues.lowestGrade.touched && formValues.lowestGrade.value === null
      ? formValues.lowestGrade.errorMessage
      : "";
  const highestGradeError =
    formValues.highestGrade.touched && formValues.highestGrade.value === null
      ? formValues.highestGrade.errorMessage
      : "";
  const schoolError =
    formValues.school.touched && formValues.school.value === null
      ? formValues.school.errorMessage
      : "";
  const highestLowerThanLowestError = checkHighestLowerThanLowestError(
    lowestGradeError,
    highestGradeError,
    formValues,
  );

  return [
    lowestGradeError,
    highestGradeError,
    schoolError,
    highestLowerThanLowestError,
  ];
};
